<template>
  <v-row class="mb-2 mb-md-16">
    <v-col
      cols="12"
      :lg="!data.alignment || data.alignment === 'full' ? 12 : 9"
      :xl="!data.alignment || data.alignment === 'full' ? 12 : 8"
      :offset-lg="data.alignment === 'right' ? 3 : 0"
      :offset-xl="data.alignment === 'right' ? 4 : 0"
    >
      <v-responsive :aspect-ratio="16/9" :max-height="viewPort.height / 2">
        <v-lazy class="fill-height" height="100%">
          <iframe v-if="data.url && data.url.indexOf('cove.') !== -1" :src="data.url" :style="{width: '100%', height: '100%'}" frameborder="0" allowfullscreen webkitallowfullscreen mozallowfullscreen></iframe>
          <VuePlyr v-else class="fill-height" :style="{width: '100%', height: '100%'}" :options="{controls: !data.gifLike ? ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'] : false, autoplay: data.gifLike, loop: {active: data.gifLike}}">
            <div v-if="data.url" :data-plyr-provider="data.url.indexOf('vimeo.com') !== -1 ? 'vimeo' : 'youtube'" :data-plyr-embed-id="getVideoId(data.url).id"></div>
            <video v-else-if="data.videoFile" :style="{width: '100%', height: '100%'}" :autoplay="data.gifLike" :loop="data.gifLike" :playsinline="data.gifLike" :muted="data.gifLike">
              <source :src="`/media/${data.videoFile.id}`" :type="data.videoFile.mimeType">
            </video>
          </VuePlyr>
        </v-lazy>
      </v-responsive>
      <MarkdownBlock class="pt-8 grey--text text--darken-1" v-if="data.caption" :text="data.caption" />
    </v-col>
  </v-row>
</template>

<script>
import VuePlyr from 'vue-plyr'
import 'plyr/dist/plyr.css'
import getVideoId from 'get-video-id'
import { MarkdownBlock, Viewport } from '@monogrid/vue-lib'

export default {
  name: 'ContentVideo',
  mixins: [Viewport],
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  methods: {
    getVideoId
  },
  components: {
    VuePlyr,
    MarkdownBlock
  }
}
</script>
